import React from "react";
import { Icon } from "../Icon/Icon";
import { ModalStyles, maxWidthHelper } from "./styles.module";

interface IModalProps {
  title?: string;
  show?: boolean;
  darkShadow?: boolean;
  closeByShadow?: boolean;
  onHide?(): void;
  width?: number;
  closeBtn?: boolean;
  children?: React.ReactNode;
}

interface IModalState {
  count: number;
}

export class Modal extends React.Component<IModalProps, IModalState> {
  state: IModalState = {
    count: 0,
  };

  widthHelper() {
    return this.props.width ? `max-width: ${this.props.width}px` : "";
  }

  stopPropagation(e: any) {
    e.stopPropagation();
  }

  closeByShadow() {
    if (this.props.closeByShadow) {
      this.props.onHide && this.props.onHide();
    }
  }

  render() {
    return (
      <ModalStyles>
        <div
          className={`shadow ${this.props.show ? "show" : ""} ${this.props.darkShadow ? "shadow--dark" : ""}`}
          onClick={() => {
            this.closeByShadow();
          }}
        >
          <div
            className={`modal fade ${maxWidthHelper(this.props.width)}`}
            role="dialog"
            onClick={this.stopPropagation}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="typo typo-h5" id="exampleModalLongTitle">
                    {this.props.title}
                  </h5>
                  {!!this.props.closeBtn ? (
                    <Icon
                      icon="close"
                      className="modal-header__close"
                      onClick={() => {
                        this.props.onHide && this.props.onHide();
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="modal-body">{this.props.children}</div>
                {/* <div className="modal-footer">
                      footer
                    </div> */}
              </div>
            </div>
          </div>
        </div>
      </ModalStyles>
    );
  }
}
